// GENERATED by scripts/prepare_hero.py — do not edit by hand.
// Re-run the script to regenerate. Every file listed here is cropped
// below the chin: no face reaches the build.

export const HERO_IMAGE = {
  "layered": true,
  "alt": "Powder-mint anarkali with hand-worked zari cuffs and a gold-bordered dupatta",
  "flat": [
    {
      "w": 533,
      "webp": "/works/hero-flat-533.webp",
      "bytes": 112364,
      "jpg": "/works/hero-flat-533.jpg"
    }
  ],
  "figure": [
    {
      "w": 533,
      "webp": "/works/hero-figure-533.webp",
      "bytes": 53150
    }
  ],
  "wall": [
    {
      "w": 533,
      "webp": "/works/hero-wall-533.webp",
      "bytes": 60407,
      "jpg": "/works/hero-wall-533.jpg"
    }
  ],
  "dupatta": null,
  "matte": "rembg"
};

export default HERO_IMAGE;
